import { ListButton, RefreshButton, Show } from "@refinedev/antd";

import { Space, Tag, Row, Col } from "antd";
import { IResourceComponentsProps, useShow } from "@refinedev/core";
import {
  RocketOutlined,
  MailOutlined,
  SettingOutlined,
  BankOutlined,
} from "@ant-design/icons";

import { IEntmVessels } from "interfaces";
import prettyBytes from "pretty-bytes";
import React from "react";
import {
  ShowField,
  ShowSection,
  ShowFieldGrid,
} from "components/show";

export const EntmVesselsShow: React.FC<IResourceComponentsProps> = () => {
  const { result, query: { isLoading } } = useShow<IEntmVessels>();
  const record = result;

  return (
    <Show
      breadcrumb={false}
      isLoading={isLoading}
      headerProps={{
        onBack: () => window.history.back(),
        title: "eNTM Vessel",
        subTitle: "active eNTM vessel",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
        extra: (
          <Space>
            <ListButton resource="entm-vessels">eNTM Vessels</ListButton>
            <RefreshButton resource="entm-vessels" recordItemId={record?.id} />
          </Space>
        ),
      }}
    >
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        {/* Vessel Identification */}
        <ShowSection
          title="Vessel Identification"
          subtitle="Primary vessel details and identifiers"
          icon={<RocketOutlined />}
          variant="elevated"
        >
          <ShowFieldGrid columns={2}>
            <ShowField label="Vessel Name" value={record?.name} />
            <ShowField label="IMO Number" value={record?.imoNumber} type="code" copyable />
            <ShowField label="UKHO Licence" value={record?.ukhoLicence} type="code" copyable />
            <ShowField label="Vessel Identifier" value={record?.vesselIdentifier} type="code" copyable />
          </ShowFieldGrid>
        </ShowSection>

        <Row gutter={24}>
          {/* Company */}
          <Col xs={24} lg={12}>
            <ShowSection
              title="Company"
              subtitle="Associated shipping company"
              icon={<BankOutlined />}
              variant="default"
            >
              <ShowFieldGrid columns={1}>
                <ShowField label="Shipco" value={record?.shipco} />
              </ShowFieldGrid>
            </ShowSection>
          </Col>

          {/* Status */}
          <Col xs={24} lg={12}>
            <ShowSection
              title="Status"
              subtitle="Hold and activity status"
              icon={<SettingOutlined />}
              variant="default"
            >
              <ShowFieldGrid columns={1}>
                <ShowField label="Hold Status" value={record?.holdStatus} type="status" />
              </ShowFieldGrid>
            </ShowSection>
          </Col>
        </Row>

        <Row gutter={24}>
          {/* Communication */}
          <Col xs={24} lg={12}>
            <ShowSection
              title="Communication"
              subtitle="Contact information"
              icon={<MailOutlined />}
              variant="subtle"
            >
              <ShowFieldGrid columns={1}>
                <ShowField label="Email" value={record?.email} type="email" />
              </ShowFieldGrid>
            </ShowSection>
          </Col>

          {/* Transmission Settings */}
          <Col xs={24} lg={12}>
            <ShowSection
              title="Transmission Settings"
              subtitle="Size limits for data transfer"
              icon={<SettingOutlined />}
              variant="subtle"
            >
              <ShowFieldGrid columns={2}>
                <ShowField label="Max Email Size" value={record?.maxEmailSizeKb ? prettyBytes(Number(record.maxEmailSizeKb)) : null} />
                <ShowField label="Max Transmission Size" value={record?.maxTransmissionSizeMb ? prettyBytes(Number(record.maxTransmissionSizeMb) * 1024 * 1024) : null} />
              </ShowFieldGrid>
            </ShowSection>
          </Col>
        </Row>
      </Space>
    </Show>
  );
};
